import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GenericDocContainerModel } from 'blg-akaun-ts-lib';
import { SubSink } from 'subsink2';
import { Observable } from 'rxjs';
import { SharedUtilitiesHelperFunctions } from '../helper-functions';

@Component({
  selector: 'app-util-generic-document-view-line',
  templateUrl: './generic-document-view-line.component.html',
  styleUrls: ['./generic-document-view-line.component.css']
})
export class GenericDocumentViewLineComponent implements OnInit, OnDestroy {
  @Input() genericDoc$: Observable<any>;
  @Input() localState: any;
  protected subs = new SubSink();

  defaultColDef = {
    filter: 'agTextColumnFilter',
    floatingFilterComponentParams: {suppressFilterButton: true},
    minWidth: 100,
    flex: 1,
    sortable: true,
    resizable: true,
    suppressCsvExport: true,
    floatingFilter: true
  };

  genericDoc: GenericDocContainerModel;
  gridApi;
  rowData: [];

  columnsDefs = [
    {headerName: 'Item Code', field: 'item_code', cellStyle: {'text-align': 'left'}},
    {headerName: 'Item Name', field: 'item_name', cellStyle: {'text-align': 'left'}},
    {headerName: 'UOM', field: 'uom', cellStyle: {'text-align': 'left'}},
    {headerName: 'Qty', field: 'qty', type: 'numericColumn'},
    {headerName: 'Unit Price', field: 'unit_price', type: 'numericColumn',
      valueFormatter: params => params.value ? SharedUtilitiesHelperFunctions.currencyFormatter(params.value) : '0.00'},
    {headerName: 'Amount Std', field: 'amount_discount', type: 'numericColumn',
      valueFormatter: params => params.value ? SharedUtilitiesHelperFunctions.currencyFormatter(params.value) : '0.00'},
    {headerName: 'Amount Discount', field: 'amount_discount', type: 'numericColumn',
      valueFormatter: params => params.value ? SharedUtilitiesHelperFunctions.currencyFormatter(params.value) : '0.00'},
    {headerName: 'SST/VAT/GST', field: 'amount_tax_gst', type: 'numericColumn',
      valueFormatter: params => params.value ? SharedUtilitiesHelperFunctions.currencyFormatter(params.value) : '0.00'},
    {headerName: 'Amount Txn', field: 'amount_txn', type: 'numericColumn',
      valueFormatter: params => params.value ? SharedUtilitiesHelperFunctions.currencyFormatter(params.value) : '0.00'},
  ];

  ccyCode;
  total: number = 0;
  tax: number = 0;

  constructor() { }

  ngOnInit() {
    this.subs.sink = this.genericDoc$.subscribe(resolve =>{
      this.genericDoc = resolve;
      this.ccyCode = resolve.bl_fi_generic_doc_hdr.doc_ccy;
      resolve.bl_fi_generic_doc_line.filter(l=>l.status==='ACTIVE' && l.txn_type==='PNS').forEach(item => {
        this.total += <number>item.amount_txn;
        this.tax += <number>item.amount_tax_gst;
      })
    })
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
    this.gridApi.setRowData(this.createData());
    this.gridApi.sizeColumnsToFit();
  }

  createData() {
    const lineItems = this.genericDoc.bl_fi_generic_doc_line.filter(l=>l.status==='ACTIVE' && l.txn_type==='PNS').map(item => {
      return {
        item_code: item.item_code,
        item_name: item.item_name,
        uom: item.item_property_json?.['uom'],
        qty: item.quantity_base,
        unit_price: item.quantity_base?(<number>item.amount_net / <number>item.quantity_base):null,
        amount_std: item.amount_std,
        amount_discount: item.amount_discount,
        amount: item.amount_net,
        amount_tax_gst: item.amount_tax_gst,
        amount_txn: item?.amount_txn
      };
    });

    return lineItems;
  }

  ngOnDestroy() {
    this.subs.unsubscribe;
  }

}
